import { all, call, put, takeLatest, select } from "redux-saga/effects";

import actions from "../../constants/actions";
import { createOptions } from "../../utils/helper";
import { GET } from "../../utils/api";
import Schemas from "../models";
import { getBlogListPagination } from "../selectors/blog";
import { getLocale } from "../selectors/app";

export function* getArticle({ payload }) {
    let options = createOptions(payload.options);
    const locale = yield select(getLocale);

    try {
        let response = yield call(GET, {
            url: "api/blog/" + payload.slug + options,
            schema: Schemas.BLOG,
            locale,
        });

        yield put({
            type: actions.BLOG.LOAD_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({
            type: actions.BLOG.LOAD_FAIL,
            payload: error,
        });
    }
}

export function* getRelatedArticles({ payload }) {
    let options = createOptions(payload.options);
    const locale = yield select(getLocale);

    try {
        let response = yield call(GET, {
            url: "api/blog/" + payload.slug + "/related" + options,
            schema: Schemas.BLOG_ARRAY,
            locale,
        });

        yield put({
            type: actions.BLOG.LOAD_RELATED_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({
            type: actions.BLOG.LOAD_RELATED_FAIL,
            payload: error,
        });
    }
}

export function* getBlog({ payload }) {
    const locale = yield select(getLocale);

    let page = 1;
    if (!payload.refresh) {
        let pagination = yield select(getBlogListPagination);

        if (pagination && pagination.current_page < pagination.last_page)
            page = pagination.current_page + 1;
    }

    let options = createOptions(payload.options, page);

    try {
        let response = yield call(GET, {
            url: "api/blog" + options,
            schema: Schemas.BLOG_ARRAY,
            locale,
        });

        yield put({
            type: actions.BLOG.LOAD_LIST_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({
            type: actions.BLOG.LOAD_LIST_FAIL,
            payload: error,
        });
    }
}

export function* getTags({ payload }) {
    const locale = yield select(getLocale);

    let options = createOptions(payload.options);

    try {
        let response = yield call(GET, {
            url: "api/tags" + options,
            locale,
        });

        yield put({
            type: actions.BLOG.LOAD_TAGS_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({
            type: actions.BLOG.LOAD_TAGS_FAIL,
            payload: error,
        });
    }
}

export default function* Blog() {
    yield all([
        yield takeLatest(actions.BLOG.LOAD, getArticle),
        yield takeLatest(actions.BLOG.LOAD_RELATED, getRelatedArticles),
        yield takeLatest(actions.BLOG.LOAD_LIST, getBlog),
        yield takeLatest(actions.BLOG.LOAD_TAGS, getTags),
    ]);
}
